'use strict';

var React = require('react');

var SvgCircleMinusMinor = function SvgCircleMinusMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 10a1 1 0 0 1-1 1h-8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1zm-5-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  }));
};

exports.SvgCircleMinusMinor = SvgCircleMinusMinor;
